import React, { } from 'react';
import Link from 'next/link';

import BaseLink from 'u9/components/baseLink/baseLink';

import * as Styled from './footer.styles';
import { colors } from 'utils/styles/theme';

interface FooterProps {}

const Contact = () => {
  return (
    <Styled.Col>
      <Styled.ColTitle>Get in Touch at</Styled.ColTitle>
      <Styled.ColContent>
        <BaseLink label="contact@u9t.com" color={'pattensBlue'} href="mailto:contact@u9t.com"/>
        <br />
        <BaseLink label="+44 207 613 3330" color={'pattensBlue'} href="tel:+44 207 613 3330"/>
      </Styled.ColContent>
    </Styled.Col>
  )
}

const Address = () => {
  return (
    <Styled.Col>
      <Styled.ColTitle>Our Office</Styled.ColTitle>
      <Styled.ColContent>
        <Styled.LayoutHref>
          <a href="https://www.google.com/maps/place/UNIT9/@51.5452958,-0.1066522,17z/data=!4m14!1m7!3m6!1s0x48761cbafb2bb617:0x1d4a1d270a0dcb73!2sUNIT9!8m2!3d51.5452958!4d-0.1040773!16s%2Fg%2F1tj910b1!3m5!1s0x48761cbafb2bb617:0x1d4a1d270a0dcb73!8m2!3d51.5452958!4d-0.1040773!16s%2Fg%2F1tj910b1?entry=ttu" target="_blank">
            12 Swan Yard <br />
            London N1 1SD <br />
            UK
          </a>
        </Styled.LayoutHref>
      </Styled.ColContent>
    </Styled.Col>
  )
}


const FooterLegal = () => {
  return (
    <Styled.FooterLegal>
      <div>Unit9 © 2021</div>
      <Link href="/privacy-policy">
        <BaseLink label="Privacy Policy" color={'pattensBlue'}/>
      </Link>
    </Styled.FooterLegal>
  )
}

const Footer = ({ ...restProps }: FooterProps) => {
  return (
    <Styled.Footer>
      <Styled.Cols>
        <Contact />
        <Address />
      </Styled.Cols>
      <FooterLegal />
    </Styled.Footer>
  );
};

// Aliases
export { Contact, Address };

export default Footer;
